/*
 * This page's live-updates connection, sent with each change so the API doesn't tell this page
 * about its own changes. Set by live.ts; kept apart so the API client needn't load it.
 */
let current: () => string | null = () => null;

export function setLiveConnection(id: () => string | null): void {
  current = id;
}

export function liveConnection(): string | null {
  return current();
}
